module.exports = __webpack_public_path__ + "4a852cc08189d356f0d68fa382ce3bb9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/multiLanguages.svg
// module id = 194
// module chunks = 0